/**
 * Government Intake Redux Slice
 *
 * Manages state for the intake form flow with Redux Persist.
 * Mirrors smeOnboarding pattern: payload, progress, and optional draft id.
 */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { EMPTY_INTAKE_PAYLOAD, type IntakePayload } from '../types/intake.types';

export interface GovernmentIntakeState {
  intakePayload: IntakePayload | null;
  currentStep: number;
  completedSteps: string[];
  intakeId: string | null;
}

const initialState: GovernmentIntakeState = {
  intakePayload: EMPTY_INTAKE_PAYLOAD,
  currentStep: 0,
  completedSteps: [],
  intakeId: null,
};

const governmentIntakeSlice = createSlice({
  name: 'governmentIntake',
  initialState,
  reducers: {
    setIntakePayload: (state, action: PayloadAction<IntakePayload>) => {
      state.intakePayload = action.payload;
    },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    markStepComplete: (state, action: PayloadAction<string>) => {
      if (!state.completedSteps.includes(action.payload)) {
        state.completedSteps.push(action.payload);
      }
    },
    setIntakeId: (state, action: PayloadAction<string | null>) => {
      state.intakeId = action.payload;
    },
    resetIntake: () => initialState,
  },
});

export const { setIntakePayload, setCurrentStep, markStepComplete, setIntakeId, resetIntake } = governmentIntakeSlice.actions;

export default governmentIntakeSlice.reducer;
